<template>
  <SingleNumberFrame
      title="# of routes"
      :value="itemData"
  >
  </SingleNumberFrame>
</template>

<script>

import SingleNumberFrame from './SingleNumberFrame.vue';

export default {
  name: 'SingleNumberFlightNumberNumbers.',
  components: {
    SingleNumberFrame,
  },

  props: {
    itemData: {
      type: [Number, String],
      default: null,
    },
  },
};
</script>
